import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _typeof from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _defineProperty from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.starts-with.js";
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "application"
};
var _hoisted_2 = {
  class: "application-top"
};
var _hoisted_3 = {
  class: "application-top-logo"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "overflow-auto"
};
var _hoisted_6 = ["onClick", "onMouseenter", "onMouseleave"];
var _hoisted_7 = {
  class: "application-top-tabs-img"
};
var _hoisted_8 = ["src"];
var _hoisted_9 = ["src"];
var _hoisted_10 = {
  class: "boxiao-box"
};
var _hoisted_11 = {
  class: "boxiao-top"
};
var _hoisted_12 = {
  class: "school-seletc"
};
var _hoisted_13 = ["src"];
var _hoisted_14 = {
  key: 1,
  class: "unuseable"
};
import { ref, onMounted, onBeforeUnmount, watch } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
import { useRoute, useRouter } from 'vue-router';
import { getStore } from '@/util/store';
import { env_name, toLogin } from '@/util/util';
import navLeft from '@/components/navLeft';
import { getAppAlias } from '@/api/home.js';
import { getAuthSchoolList, saveCurrentSchool } from '@/api/boxiao.js';
import nopermission from '@/components/nopermission';
var DEFAULT_TITLE = '慧学慧研';
export default {
  __name: 'boxiao',
  setup: function setup(__props) {
    var _route$query;
    var route = useRoute();
    var router = useRouter();
    var visibleLeftBar = ref(true);
    var Iframe = ref(null);
    var bxUseable = ref(false);
    var bxUrl = ref('');
    var appMenus = ref([]);
    var curMenuPath = ref(route.query[route.name] ? route.query[route.name].toString() + 0 : '');
    var mouseenter = function mouseenter(e, url) {
      e.target.className.indexOf('active') === -1 && (e.target.firstChild.src = require("@/assets/nav/".concat(url, "-active.svg")));
    };
    var mouseleave = function mouseleave(e, url) {
      e.target.className.indexOf('active') === -1 && (e.target.firstChild.src = require("@/assets/nav/".concat(url, ".svg")));
    };
    var access_token = getStore({
      name: 'access_token'
    }); // 传递token到子应用
    var accessInfo = getStore({
      name: 'accessInfo'
    }); // 传递accessInfo到子应用
    var appAllList = getStore({
      name: 'platformApps'
    }); // 获取所有应用列表

    var appInfo = appAllList.find(function (item) {
      return route.name === item.appAlias;
    });
    var navClick = function navClick(item, index) {
      visibleLeftBar.value = true;
      pageTitle.value = item.name;
      curMenuPath.value = item.path + index;
      bxUrl = getUrl(item.path) + "&schoolId=".concat(currentSchoolId.value);
      if (item.path && item.path !== route.query[route.name] && (route.query[route.name] !== undefined || index !== 0)) {
        router.push({
          path: route.path,
          query: _defineProperty({}, route.name, item.path)
        });
      }
    };
    if ((_route$query = route.query) !== null && _route$query !== void 0 && _route$query.hideLeftBar) {
      visibleLeftBar.value = false;
    }

    // 获取app信息 渲染左侧头部图片
    var icon = ref('');
    getAppAlias(route.name).then(function (res) {
      if (res.data.code === 0) {
        if (res.data.data && res.data.data.result === 'access') {
          var _res$data$data, _res$data$data2, _res$data$data3;
          icon.value = (_res$data$data = res.data.data) === null || _res$data$data === void 0 || (_res$data$data = _res$data$data.app) === null || _res$data$data === void 0 ? void 0 : _res$data$data.icon;
          appMenus.value = (_res$data$data2 = res.data.data) === null || _res$data$data2 === void 0 ? void 0 : _res$data$data2.menus;
          checkUseable((_res$data$data3 = res.data.data) === null || _res$data$data3 === void 0 || (_res$data$data3 = _res$data$data3.app) === null || _res$data$data3 === void 0 ? void 0 : _res$data$data3.memberTypes);
          getPageInfo();
        } else {
          MessagePlugin.info('您暂无该应用权限');
          router.push({
            path: '/'
          });
        }
      }
    });
    var checkUseable = function checkUseable(types) {
      if (!types || types.length === 0) {
        return;
      }
      if (types && types.length === 1 && types[0].type === 'student') {
        bxUseable.value = accessInfo.memberType && accessInfo.memberType.length === 1 && accessInfo.memberType[0] === 'student' || accessInfo.memberType === 'student';
        return;
      }
      if (types && types.length === 1 && types[0].type !== 'student') {
        bxUseable.value = true;
        return;
      }
      if (types && types.length > 1) {
        bxUseable.value = true;
      }
    };
    var objectToQueryString = function objectToQueryString(obj) {
      if (!obj || _typeof(obj) !== 'object' || Object.keys(obj).length === 0) {
        return '';
      }
      return Object.entries(obj).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        if (value !== undefined && value !== null && value !== '') {
          return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value));
        }
        return null;
      }).filter(Boolean).join('&');
    };

    // 获取博校应用地址
    var getUrl = function getUrl(checkUrl) {
      var surfix = checkUrl || appMenus.value[0].path;
      var domain = appInfo.projectUrl.endsWith('/') ? appInfo.projectUrl.slice(0, -1) : appInfo.projectUrl;
      var domainPath = surfix.startsWith('/') ? surfix : "/".concat(surfix);
      var appUrl = domain + domainPath;
      var curmenu = appMenus.value.find(function (item) {
        return item.path === surfix;
      });
      var qs = '';
      if (curmenu && curmenu.props) {
        qs = objectToQueryString(JSON.parse(curmenu.props));
      }
      surfix.split('/').length > 1 ? surfix = surfix.slice(1) : '';
      var url = '';
      if (route.name === 'boxiaoAchievementManage') {
        var tail = appUrl.split('/').reverse()[0];
        appUrl = appUrl.replace(tail, '');
      } else if (route.name === 'boxiaoStuAskForLeaveTeacher' || route.name === 'boxiaoStuAskForLeaveManage') {
        var clipList = ['gradeDirectorIndex', 'headTeacherIndex'];
        var _tail = appUrl.split('/').reverse()[0];
        if (clipList.includes(_tail)) {
          appUrl = appUrl.replace(_tail, '');
        }
      }
      url = "//".concat(env_name).concat(appUrl, "?bayToken=").concat(access_token).concat(qs ? "&".concat(qs) : '');
      return url;
    };

    // 右侧标题
    var pageTitle = ref('');
    var setTitle = function setTitle() {
      var curmenu = route.query[route.name];
      pageTitle.value = curmenu ? appMenus.value.find(function (item) {
        return item.path === curmenu;
      }).name : appMenus.value[0].name;
    };

    // 获取页面信息
    var getPageInfo = function getPageInfo() {
      isFresh.value = true;
      bxUrl = getUrl(route.query[route.name]);
      setTitle();
    };

    // 子应用菜单栏动态管理
    var isFresh = ref(false);

    // 动态修改导航名称
    if (appInfo) {
      document.title = appInfo.appName;
    } else {
      document.title = DEFAULT_TITLE;
    }
    var schoolList = ref(null);
    var currentSchoolId = ref(null);
    // 获取学校列表
    var getSchoolList = function getSchoolList() {
      getAuthSchoolList().then(function (res) {
        schoolList.value = res.data.data;
        var currentSchool = schoolList.value.filter(function (item) {
          return item.isCurrentSchool;
        });
        if (currentSchool && currentSchool.length) {
          currentSchoolId.value = currentSchool[0].schoolId;
        } else {
          currentSchoolId.value = schoolList.value[0].schoolId;
        }
        changeSChool(currentSchoolId.value);
      });
    };
    getSchoolList();
    // 切换学校
    var changeSChool = function changeSChool(id) {
      saveCurrentSchool(id).then(function (res) {
        Iframe.value && (Iframe.value.src = bxUrl + "&schoolId=".concat(id));
      });
    };
    var _removeDownloadsTag = function removeDownloadsTag() {
      if (Iframe.value && Iframe.value.sandbox) {
        Iframe.value.sandbox.remove('allow-downloads');
      } else {
        setTimeout(function () {
          _removeDownloadsTag();
        }, 500);
      }
    };

    // 监听路由变化
    watch(function () {
      return route.name;
    }, function (value) {
      appInfo = appAllList.find(function (item) {
        return value === item.appAlias;
      });
      if (appInfo) {
        document.title = appInfo.appName;
      } else {
        document.title = DEFAULT_TITLE;
      }
    });
    onMounted(function () {
      window.addEventListener('message', function (ev) {
        if (ev.origin.includes('')) {
          var _ev$data = ev.data,
            type = _ev$data.type,
            fileName = _ev$data.fileName,
            fileUrl = _ev$data.fileUrl,
            pageUrl = _ev$data.pageUrl;
          if (type === 'download') {
            window.JSAndroid && window.JSAndroid.downLoadSource(JSON.stringify({
              title: fileName,
              url: fileUrl
            }));
          } else if (type === 'tokenunfresh') {
            toLogin();
          } else if (type === 'newtabview') {
            if (window.JSAndroid) {
              window.JSAndroid.startNewWeb(JSON.stringify({
                showTitle: true,
                title: '',
                url: pageUrl
              }));
            } else {
              window.open(pageUrl, '_blank');
            }
          }
        }
      });
      // 平板端去除iframe下载
      if (window.JSAndroid) {
        _removeDownloadsTag();
      }
    });
    onBeforeUnmount(function () {
      document.title = DEFAULT_TITLE;
      window.removeEventListener('message', function () {});
    });
    return function (_ctx, _cache) {
      var _component_t_option = _resolveComponent("t-option");
      var _component_t_select = _resolveComponent("t-select");
      return isFresh.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createVNode(_unref(navLeft), null, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
            src: icon.value,
            alt: ""
          }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appMenus), function (item, index) {
            var _ctx$$route$query$_ct, _ctx$$route$query$_ct2;
            return _openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["application-top-tabs", {
                active: ((_ctx$$route$query$_ct = _ctx.$route.query[_ctx.$route.name]) === null || _ctx$$route$query$_ct === void 0 ? void 0 : _ctx$$route$query$_ct.toString()) + index === _unref(curMenuPath) || _ctx.$route.query[_ctx.$route.name] === undefined && index === 0
              }]),
              key: index,
              onClick: function onClick($event) {
                return navClick(item, index);
              },
              onMouseenter: function onMouseenter(e) {
                return mouseenter(e, item.icon);
              },
              onMouseleave: function onMouseleave(e) {
                return mouseleave(e, item.icon);
              }
            }, [_createElementVNode("div", _hoisted_7, [((_ctx$$route$query$_ct2 = _ctx.$route.query[_ctx.$route.name]) === null || _ctx$$route$query$_ct2 === void 0 ? void 0 : _ctx$$route$query$_ct2.indexOf(item.path)) > -1 || _ctx.$route.query[_ctx.$route.name] === undefined && index === 0 ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: item.icon ? require("@/assets/nav/".concat(item.icon, "-active.svg")) : ''
            }, null, 8, _hoisted_8)) : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: item.icon ? require("@/assets/nav/".concat(item.icon, ".svg")) : ''
            }, null, 8, _hoisted_9))]), _createElementVNode("div", null, _toDisplayString(item.name), 1)], 42, _hoisted_6);
          }), 128))])])];
        }),
        _: 1
      }, 512), [[_vShow, visibleLeftBar.value]]), _createElementVNode("div", _hoisted_10, [_unref(appMenus).length ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("span", null, _toDisplayString(pageTitle.value), 1), _createElementVNode("div", _hoisted_12, [_createVNode(_component_t_select, {
        autoWidth: "",
        borderless: "",
        modelValue: currentSchoolId.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return currentSchoolId.value = $event;
        }),
        onChange: changeSChool
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schoolList.value, function (item) {
            return _openBlock(), _createBlock(_component_t_option, {
              key: item.schoolId,
              value: item.schoolId,
              label: item.schoolName
            }, null, 8, ["value", "label"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])])]), bxUseable.value ? (_openBlock(), _createElementBlock("iframe", {
        key: 0,
        ref_key: "Iframe",
        ref: Iframe,
        style: {
          "flex": "1"
        },
        src: _unref(bxUrl),
        sandbox: "allow-scripts allow-forms allow-same-origin allow-top-navigation allow-popups allow-downloads"
      }, null, 8, _hoisted_13)) : (_openBlock(), _createElementBlock("div", _hoisted_14, _toConsumableArray(_cache[1] || (_cache[1] = [_createElementVNode("span", null, "您当前用户为多重身份，本应用限制有且只有学生身份的用户使用", -1)]))))], 64)) : (_openBlock(), _createBlock(_unref(nopermission), {
        key: 1
      }))])])) : _createCommentVNode("", true);
    };
  }
};